import styles from "./styles.module.scss";
import cn from "classnames";
import { useEffect, useRef } from "react";

export const ImageTicker = ({ images = [], className }) => {
  const tickerRef = useRef(null);

  useEffect(() => {
    const ticker = tickerRef.current;
    if (ticker) {
      ticker.style.animation = `${styles.scroll} 40s linear infinite`;
    }
  }, []);

  // Duplicate array for seamless loop effect
  const doubled = [...images, ...images];

  return (
    <section className={cn(styles.ImageTicker, className)}>
      <div className={styles.gradientLeft} />
      <div className={styles.gradientRight} />
      <div className={styles.track} ref={tickerRef}>
        {doubled.map((item, idx) => (
          <img
            key={idx}
            src={item?.image?.url || ""}
            alt={item?.image?.alt || ""}
            className={styles.image}
            data-sourceflow-prop={`images[${idx % images.length}].image`}
          />
        ))}
      </div>
    </section>
  );
};

export default ImageTicker;
